// common/services/b2b.api.ts
import { ICompanyB2B } from "@/types/companyB2B.type";
import { ApiResponseType, makeRequest } from "../helpers/api.helpers";
import { createDebounce } from "../helpers/debounce.helper";
import { IVehicleB2BDetails } from "@/types/contractB2B.type";

const API_URL = `${import.meta.env.VITE_API_URL}/company-b2b`;

const makeRequestDebounced = createDebounce(makeRequest, 200);

export async function getEmpresasB2B({
  search = "",
  status = "",
  page = 1,
  itemsPerPage = 10,
  orderBy = "socialReason",
  fields = "_id, cnpj, socialReason, name, active, companyId",
} = {}) {
  const params = new URLSearchParams({
    page: String(page),
    itemsPerPage: String(itemsPerPage),
    fields,
  });
  let activeStatus: string | undefined;
  if (Array.isArray(status) && status.length > 0) {
    if (status.includes("ACTIVE") && !status.includes("INACTIVE")) {
      activeStatus = "true";
    } else if (status.includes("INACTIVE") && !status.includes("ACTIVE")) {
      activeStatus = "false";
    }
  } else if (typeof status === "string" && status) {
    if (status === "ACTIVE") activeStatus = "true";
    if (status === "INACTIVE") activeStatus = "false";
  }

  activeStatus && params.append("filters[active]", activeStatus);
  search && params.append("search", search);
  orderBy && params.append("orderBy", orderBy);

  const url = `${API_URL}/?${params.toString()}`;
  const result = (await makeRequestDebounced(url)) as ApiResponseType<
    ICompanyB2B[]
  > & { totalItems: number };
  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function getCompanyB2BById(id: string) {
  const url = `${API_URL}/${id}`;
  const result = (await makeRequest(url)) as ApiResponseType<ICompanyB2B>;
  return { ok: result.ok, data: result.data };
}

export async function getPaymentsB2B(id: string) {
  const url = `${API_URL}/${id}/payments`;

  const result = (await makeRequest(url)) as ApiResponseType<
    IVehicleB2BDetails[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function syncPaymentsB2B(id) {
  const url = `${API_URL}/${id}/sync-payments`;

  const result = (await makeRequest(url)) as ApiResponseType<
    IVehicleB2BDetails[]
  > & { totalItems: number };

  return { ok: result.ok, data: result.data, totalItems: result.totalItems };
}

export async function createCompanyB2B(empresaData: Partial<ICompanyB2B>) {
  const url = `${API_URL}/`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(empresaData),
  };
  return makeRequestDebounced(url, options) as Promise<
    ApiResponseType<ICompanyB2B>
  >;
}

export async function createdBillingB2B(companyId: string, billingData) {
  const url = `${API_URL}/${companyId}/billings`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(billingData),
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const result = (await makeRequestDebounced(url, options)) as ApiResponseType<any>;
  return { ok: result.ok };
}

export async function getVehiclesDetailsByPlates(licensePlates: string[]) {
  const url = `${API_URL}/vehicles/details-by-plates`;
  const options = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ licensePlates }),
  };

  const result = (await makeRequest(url, options)) as ApiResponseType<
    IVehicleB2BDetails[]
  >;

  return { ok: result.ok, data: result.data };
}
